module.exports = __webpack_public_path__ + "static/media/fk-vitebsk.42d84617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/fk-vitebsk.png
// module id = 528
// module chunks = 0